/* eslint-disable indent */
import React from 'react';
import { GridColDef, GridRenderCellParams } from '@mui/x-data-grid';
import i18n from '../../../translations/i18n';
import { ActivityLog } from '../../../api/activitiesApi/interfaces';
import { formatLocaleDate } from '../../../helpers/dateHelpers';
import { AgentBadge } from '../../../components/AgentBadge';
import { Badge, Typography } from '@mui/material';
import { ValueCell } from '../../../components/data-table';
import { IncludedInContactIntervalStatus } from './components/IncludedInContactIntervalStatus';

export const getColumns = (hideClientColumn: boolean = false): GridColDef[] => [
  {
    field: 'performedAt',
    headerName: i18n.t('entities:common.date'),
    width: 200,
    renderCell: (params) => {
      const dateAsStr = formatLocaleDate(params.row.performedAt);

      if (params.row.hasOngoingActivity) {
        return (
          <ValueCell>
            <Badge
              color="info"
              variant="dot"
              anchorOrigin={{
                vertical: 'top',
                horizontal: 'left',
              }}
            >
              <Typography variant="body2">{dateAsStr}</Typography>
            </Badge>
          </ValueCell>
        );
      } else {
        return dateAsStr;
      }
    },
    hideable: false,
  },
  {
    field: 'action',
    headerName: i18n.t('entities:activityLog.action'),
    width: 150,
    valueGetter: (action: ActivityLog['action']) => action.name,
  },
  {
    field: 'contacts',
    headerName: i18n.t('entities:activityLog.contacts'),
    minWidth: 150,
    flex: 1,
    renderCell: (params) => {
      const contacts = params.row.contacts as ActivityLog['contacts'];

      if (!contacts.length) {
        return '-';
      }

      return (
        <span>
          {contacts
            .map((contact) => `${contact.firstName} ${contact.lastName}`)
            .join(', ')}
        </span>
      );
    },
  },
  ...(!hideClientColumn
    ? [
        {
          field: 'client',
          headerName: i18n.t('entities:activityLog.client'),
          width: 250,
          valueGetter: (client: ActivityLog['client']) => client.name,
        },
      ]
    : []),
  {
    field: 'group',
    headerName: i18n.t('entities:activityLog.group'),
    width: 150,
    renderCell: (params) => {
      const client = params.row.client as ActivityLog['client'];

      return client.group?.name || '-';
    },
  },
  {
    field: 'agent',
    headerName: i18n.t('entities:activityLog.agent'),
    width: 200,
    renderCell: (params) => {
      const row = params.row;

      return <AgentBadge agent={row.agent} />;
    },
  },
  {
    field: 'excludeFromContactInterval',
    headerName: i18n.t('activities:activityLogOverview.columns.interval'),
    flex: 1,
    renderCell: (params: GridRenderCellParams<ActivityLog>) => {
      const exclude = params.row.excludeFromContactInterval;

      return (
        <ValueCell>
          <IncludedInContactIntervalStatus status={exclude} />
        </ValueCell>
      );
    },
  },
];
